import React from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "./Buttons";

const styles = theme => ({
  container: {
    width: "100%",
    height: 200,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      height: 100,
      alignItems: "flex-start"
    }
  }
});
const CallToActionFooter = ({ classes }) => (
  <div className={classes.container}>
    <Button
      component={Link}
      size="large"
      variant="outlined"
      color="primary"
      to="/products"
    >
      See our products
    </Button>
  </div>
);

export default withStyles(styles)(CallToActionFooter);



// WEBPACK FOOTER //
// ./src/components/CallToActionFooter.js